import { Card } from "../ui/Card.jsx";
import { SectionHeading } from "../ui/SectionHeading.jsx";

export function Vision() {
  const items = [
    {
      n: "01",
      title: "Data & AI stop being a project.",
      body: "Every business will run on a continuously learning model of its customers, not a quarterly analytics report.",
    },
    {
      n: "02",
      title: "Software gets bespoke again.",
      body: "Generic SaaS templates give way to software built around how your specific business actually operates.",
    },
    {
      n: "03",
      title: "Personalization reaches everyone.",
      body: "Hyper-personalized engagement stops being a Meta- or Amazon-only capability and becomes available to any team.",
    },
  ];

  return (
    <section className="section" id="vision">
      <div className="container">
        <SectionHeading eyebrow="Our view" title="Where this is going." />
        <div className="vision-grid">
          {items.map((it) => (
            <Card key={it.n} className="vision-card" hoverable={false} data-reveal>
              <div className="vision-num">{it.n}</div>
              <h3>{it.title}</h3>
              <p>{it.body}</p>
            </Card>
          ))}
        </div>
        <div className="vision-callout" data-reveal>
          The capabilities that decide who wins are held by a handful of the largest platforms on
          earth. We are unlocking them for everyone else.
        </div>
      </div>
    </section>
  );
}
